import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { useDataAnnotation } from '../context/DataAnnotationProvider';
import {
  calculateAge,
  convertToFormattedDateString,
  isValidDate,
} from '../../../helpers';

const AnnotationPatientDetails = () => {
  const { dataAnnotationPatientProfile } = useSelector(
    (state: RootState) => state.dataAnnotation,
  );

  const { loading } = useDataAnnotation();
  const patientProfiles = React.useMemo(() => {
    const filteredEntries = Object.entries(dataAnnotationPatientProfile).filter(
      ([key]) => key !== 'Name',
    );
    return filteredEntries
      .map(([label, value]) => ({
        label,
        value: !value ? '-' : value,
      }))
      .filter(Boolean);
  }, [dataAnnotationPatientProfile]);

  const chunkedProfiles = React.useMemo(() => {
    const chunked = [];
    for (let i = 0; i < patientProfiles.length; i += 3) {
      chunked.push(patientProfiles.slice(i, i + 3));
    }
    return chunked;
  }, [patientProfiles]);

  const convertingValue = (value: string, isDob: boolean = false) => {
    if (isValidDate(value) && isDob) {
      const dob = convertToFormattedDateString(value);
      if (!dob) {
        return '-';
      }
      const { years } = calculateAge(value);
      return `${dob} (${years} years old)`;
    }
    return value;
  };

  if (loading) {
    return null;
  }
  return (
    <Col xs={10} className="d-flex flex-column justify-content-center py-3">
      {chunkedProfiles.map((profile, rowIndex) => (
        <Row key={rowIndex} className="mb-3">
          {profile.map((item, colIndex) => (
            <Col
              key={colIndex}
              md={4}
              className="d-flex flex-row gap-2 align-items-center"
            >
              <span className="data-annotation-profile-label">
                {item.label === '.Estimated Glomerular Filtration Rate'
                  ? 'eGFR'
                  : item.label}
              </span>
              <span className="data-annotation-profile-value">
                {convertingValue(
                  item.value,
                  item.label.toLowerCase() === 'dob',
                )}
              </span>
            </Col>
          ))}
        </Row>
      ))}
    </Col>
  );
};

export default AnnotationPatientDetails;
